<script>
import Product from "@/views/modules/products/Product.vue"

export default {
  name: "ProductPage",
  components: {
    Product
  }
}
</script>

<template>
  <div>
    <Product lang="ID" />
  </div>
</template>

<style scoped>
</style>
